import apiClient from './client';
import { API_ENDPOINTS } from '@/constants';

export const publicPortalApi = {
  getHome: () => apiClient.get(API_ENDPOINTS.PUBLIC_PORTAL.HOME),
  getStats: () => apiClient.get(API_ENDPOINTS.PUBLIC_PORTAL.STATS),
  search: (params) => apiClient.get(API_ENDPOINTS.PUBLIC_PORTAL.SEARCH, { params }),
  listTournaments: (params) => apiClient.get(API_ENDPOINTS.PUBLIC_PORTAL.TOURNAMENTS, { params }),
  listTournamentsPublic: (params) =>
    apiClient.get(API_ENDPOINTS.PUBLIC_PORTAL.TOURNAMENTS_LIST, { params }),
  listMatches: (params) => apiClient.get(API_ENDPOINTS.PUBLIC_PORTAL.MATCHES, { params }),
  getMatch: (id) => apiClient.get(API_ENDPOINTS.PUBLIC_PORTAL.MATCH(id)),
  listTeams: (params) => apiClient.get(API_ENDPOINTS.PUBLIC_PORTAL.TEAMS, { params }),
  getTeam: (id) => apiClient.get(API_ENDPOINTS.PUBLIC_PORTAL.TEAM(id)),
  listPlayers: (params) => apiClient.get(API_ENDPOINTS.PUBLIC_PORTAL.PLAYERS, { params }),
  getPlayer: (id) => apiClient.get(API_ENDPOINTS.PUBLIC_PORTAL.PLAYER(id)),
  listGrounds: (params) => apiClient.get(API_ENDPOINTS.PUBLIC_GROUNDS.BASE, { params }),
  getGround: (id) => apiClient.get(API_ENDPOINTS.PUBLIC_GROUNDS.BY_ID(id)),
  listGallery: (params) => apiClient.get(API_ENDPOINTS.PUBLIC_PORTAL.GALLERY, { params }),
  listAlbums: (params) => apiClient.get(API_ENDPOINTS.PUBLIC_PORTAL.ALBUMS, { params }),
  getAlbum: (id) => apiClient.get(API_ENDPOINTS.PUBLIC_PORTAL.ALBUM(id)),
  listSponsors: (params) => apiClient.get(API_ENDPOINTS.PUBLIC_PORTAL.SPONSORS, { params }),
};
